export default [
	icon: 'e'
	label: 'Scan my QR Code'
	name: 'viewqr'
	action: 'open-qr-code'
	size: 25
,
	icon: 'f'
	label: 'Add to contacts'
	name: 'save'
	# href: '/files/general/contact-card.vcf'
	size: 28
	left: -2
,
	icon: 'B'
	label: 'Add to home screen'
	name: 'addtohome'
	action: 'add-to-home'
	size: 25
,
	icon: 'C'
	label: 'Share my card'
	name: 'share'
	action: 'share-card'
	size: 25
,
	icon: 'f'
	label: 'Start your 7-day free trial'
	name: 'getyourown'
	href: "https://#{process.env.HOST_NAME}/"
	size: 25
]



